export const close_repair_display = {
  heading: "Close repair",
  close_action: "Close repair",
  close_error: "Could not close repair",
};
